import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { ErrorStateMatcher } from '@angular/material/core';
import { MyErrorStateMatcher } from './app/types/v3/custom-error-state-matcher';
import { MaintenanceGuard } from './app/app.routes';

bootstrapApplication(AppComponent, {
  providers: [
    ...(appConfig.providers ?? []),
    { provide: ErrorStateMatcher, useClass: MyErrorStateMatcher },
    MaintenanceGuard
  ]
}).catch(err => console.error(err));
